const SCHEDULE_CONFIG_PATH = 'config/schedule-config.json';

export const fetchScheduleConfig = async () => {
  try {
    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SCHEDULE_CONFIG_PATH}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      return {
        config: JSON.parse(atob(data.content)),
        sha: data.sha
      };
    }
    return {
      config: {
        time: '17:00',
        timezone: 'Asia/Kolkata',
        days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        enabled: true
      },
      sha: null
    };
  } catch (error) {
    console.error('Error fetching schedule config:', error);
    return { config: {}, sha: null };
  }
};

export const saveScheduleConfig = async (config, sha = null) => {
  try {
    const body = {
      message: 'Update schedule configuration',
      content: btoa(JSON.stringify(config, null, 2)),
      branch: 'main'
    };

    if (sha) body.sha = sha;

    await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SCHEDULE_CONFIG_PATH}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      }
    );
  } catch (error) {
    console.error('Error saving schedule config:', error);
    throw error;
  }
};